import { mdiContentCopy, mdiChevronLeft, mdiChevronRight, mdiCog, mdiClose, mdiTrashCan, mdiGoogle, mdiGithub, mdiCastConnected, mdiPlusThick, mdiPalette } from '@mdi/js';
const mdi = new Map([
    ['content-copy', mdiContentCopy],
    ['chevron-left', mdiChevronLeft],
    ['chevron-right', mdiChevronRight],
    ['cog', mdiCog],
    ['close', mdiClose],
    ['trash-can', mdiTrashCan],
    ['google', mdiGoogle],
    ['github', mdiGithub],
    ['cast-connected', mdiCastConnected],
    ['plus-thick', mdiPlusThick],
    ['palette', mdiPalette]
]);
export default mdi;
